
const DestinationCard = ({ total, image, location }) => (
  <div className="destination-card bg-transparent text-center p-1 h-100">
    <img src={image} className="rounded-circle" alt={`ImageCard of ${location.name}`} />
    <div className="card-body p-0 pt-3">
      <h5 className="card-title">
        <a href="#" className="stretched-link">
          {location.name}
        </a>
      </h5>
      <span>{total} Properties</span>
    </div>
  </div>
);

export default DestinationCard